import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfigService } from '../../services/config.service';

@Component({
  selector: 'app-download-report-dialog',
  templateUrl: './download-report-dialog.component.html',
  styleUrls: ['./download-report-dialog.component.less']
})
export class DownloadReportDialogComponent {
  url: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dialogRef: MatDialogRef<DownloadReportDialogComponent>,
    private configService: ConfigService
  ) {
    this.url = this.configService.config.analyticsWebApiBaseUrl + '/DownloadReport?id=' + data.reportId;
  }

  onClickDownload() {
    this.dialogRef.close();
  }
}

export interface DialogData {
  reportId: string;
}
